
<script>

import { useImportStore } from "../stores/import"

export default {
  setup() {
    const { importings, importDone, importTotal } = useImportStore();
    return {
      importings,
      importDone,
      importTotal,
    }
  },
  name: "AdminNavbarHeader",
  props: {
    isReduce: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    importing() {
      return this.importings;
    },
    importingStatus() {
      const { done } = this.importDone;
      const { total } = this.importTotal;
      return total ? Math.round((done / total) * 100) : 0;
    },
  },
};
</script>

<template>
  <div id="logoContainer" class="p-8 flex flex-col justify-center items-center"
    :class="[!isReduce ? 'h-16 md:h-32' : 'h-16']" style="background-image: url('/static/admin-navbar-header.png')">
    <router-view>
      <transition name="logo">
        <img v-if="!isReduce" src="/static/airbnb-icon.png" class="h-12 w-12" :class="{ spinLogo: importing }" />
      </transition>
    </router-view>
    <span class="m-3 font-semibold text-center text-gray-200" :class="!isReduce ? 'text-xl md:text-base' : 'text-xl'">{{
      !importing
      ? "Airbnb"
      : $t("components.admin_navbar_header.import", {
        status: importingStatus,
      })
    }}</span>
  </div>
</template>

<style scoped>
.logo-enter-from,
.logo-leave-to {
  @apply h-0 w-0 opacity-0;
}

.logo-enter-active {
  transition: opacity 300ms ease, height 300ms ease, width 300ms ease;
}

.logo-leave-active {
  transition: opacity 100ms ease, height 100ms ease, width 100ms ease;
}

#logoContainer {
  transition: height 400ms ease;
}

#maindiv {
  transition: width 300ms ease;
}

.spinLogo {
  transform: translateZ(1);
  animation: spin 5s infinite;
}

@keyframes spin {

  0%,
  100% {
    animation-timing-function: cubic-bezier(0.5, 0, 1, 0.5);
  }

  0% {
    transform: rotateY(0deg);
  }

  50% {
    transform: rotateY(1800deg);
    animation-timing-function: cubic-bezier(0, 0.5, 0.5, 1);
  }

  100% {
    transform: rotateY(3600deg);
  }
}
</style>
